exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".tv-alert-wrapper {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 20;\n  display: flex;\n  background-color: white;\n  transition: transform 0.3s;\n  transform: translateY(100%); }\n  .tv-alert-wrapper.visible {\n    transform: translateY(0); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/screens/tv/TVAlertSlide.scss
// module id = 890
// module chunks = 0